export default __webpack_public_path__ + "a1a658fa1304d4d16e8c89fb29896e38.svg";